import Vue from "vue";

// EventBus
const EventBus = new Vue();

export default EventBus;
